import { gql } from '@apollo/client';

export const DeleteFileMutation = gql`
    mutation DeleteFile($fileId: ID!) {
        deleteFile(fileId: $fileId)
    }
`;
